export const PAGE_URL = 'dysplan.info.pl';
export const FULL_PAGE_URL = `https://${PAGE_URL}`;

export const EMAIL = 'biuro@dysplan.pl';
export const EMAILHREF = `mailto:${EMAIL}`;

export const FB_URL = 'https://www.facebook.com/Dysplan/';
export const INSTAGRAM_URL = 'https://www.instagram.com/dysplanpiotrsurma';
